import { IBidResponse } from '../../typings/IPrebid'
import { IBidRequest } from '../../typings/IPrebidAdapter'
import { Device } from '../helpers'
import WebModel from '../models/WebModel'
import Session from '../session/Session'
import { getS2SBeta } from '../prebidFacade/s2sAdapter/BetaTest'

export const getBaseData = (model: WebModel): object => ({
  beta: 2,
  deviceType: Device.deviceType,
  domain: window.location.hostname.replace('www.', ''),
  // generator: 'web',
  group: model.versionGroup.name,
  referrer: Session.referrer,
  sessionDepth: Session.depth,
  version: model.versionGroup.version,
  s2sVersion: getS2SBeta().name
})

export const parseBidTimeout = (
  bidResponse: IBidResponse,
  model: WebModel
): object => ({
  ...getBaseData(model),
  adunit:
    bidResponse.adUnitCode &&
    bidResponse.adUnitCode.replace(/_[0-9]+|_refresh/g, ''),
  bidder: bidResponse.s2sBidder
    ? `${bidResponse.s2sBidder}_s2s`
    : bidResponse.bidder,
  generator: bidResponse.auctionId
})

export const parseBidRequest = (
  bidRequest: IBidRequest,
  model: WebModel
): object => ({
  ...getBaseData(model),
  generator: bidRequest.auctionId,
  bidder: bidRequest.bidderCode,
  timeout: bidRequest.timeout,
  bidFloor: model.floor
})

export const parseBidResponse = (
  bidResponse: IBidResponse,
  model: WebModel
): object => ({
  ...getBaseData(model),
  adunit:
    bidResponse.adUnitCode &&
    bidResponse.adUnitCode.replace(/_[0-9]+|_refresh/g, ''),
  bidder: bidResponse.s2sBidder
    ? `${bidResponse.s2sBidder}_s2s`
    : bidResponse.bidder,
  adUnitFull: bidResponse.adUnitCode,
  creativeId: String(bidResponse.creativeId),
  cpm: bidResponse.cpm,
  size: bidResponse.size,
  timeToRespond: bidResponse.timeToRespond,
  bidFloor: model.floor,
  belowFloor: bidResponse.cpm < model.floor,
  generator: bidResponse.auctionId
})

export const parseGoogletagEvent = (
  event:
    | googletag.events.ImpressionViewableEvent
    | googletag.events.SlotRenderEndedEvent,
  model: WebModel
) => ({
  ...getBaseData(model),
  ...parseTargeting(event.slot),
  generator: 'web',
  adunit: event.slot.getAdUnitPath().replace(`/1030006/${model.adunit}_`, ''),
  eventSize: event.size
})

const parseTargeting = (slot: googletag.Slot): object => {
  try {
    // @ts-ignore
    const targeting: object = slot.getTargetingMap()
    const result = {}
    Object.keys(targeting).map((k) => (result[k] = targeting[k]))

    return result
  } catch (e) {
    return {}
  }
}
